import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PageBarButtonClass } from "../pageBarButtonClass";
import { PlusIcon } from "../../icons";
import { useJourneyPlanner } from "./JourneyPlannerContext";

function JourneyPlannerNewJourneyButton() {
  const { handleCreateJourney, loading } = useJourneyPlanner();

  return (
    <button
      className={`${PageBarButtonClass} text-secondary`}
      disabled={loading}
      onClick={handleCreateJourney}
      type="button"
    >
      <FontAwesomeIcon icon={PlusIcon} className="me-2" />
      New Journey
    </button>
  );
}

export default JourneyPlannerNewJourneyButton;
